<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3>Order Details</h3>
        <button class="btn btn-secondary" (click)="goBack()">Back to Orders</button>
      </div>

      <!-- Loading indicator -->
      @if (loading) {
        <div class="d-flex justify-content-center mt-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      }

      <!-- Error message -->
      @if (error && !loading) {
        <div class="alert alert-danger mt-3">
          {{ error }}
        </div>
      }

      <!-- Order details -->
      @if (!loading && !error && order) {
        <div class="card mt-4">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h5 class="card-title">Order Information</h5>
                <p class="card-text"><strong>Order ID:</strong> {{ order.id }}</p>
                <p class="card-text"><strong>Order Code:</strong> {{ order.code }}</p>
                <p class="card-text"><strong>Package ID:</strong> {{ order.package_id }}</p>
                <p class="card-text"><strong>Package Name:</strong> {{ order.package }}</p>
                <p class="card-text"><strong>Type:</strong> {{ order.type === 'sim' ? 'Top-up' : order.type === 'initial' ? 'New' : order.type }}</p>
                <p class="card-text"><strong>Quantity:</strong> {{ order.quantity }}</p>
                <p class="card-text"><strong>ESIM Type:</strong> {{ order.esim_type === 'prepaid' ? 'Prepaid' : order.esim_type === 'postpaid' ? 'Postpaid' : order.esim_type === 'local' ? 'Local' : order.esim_type }}</p>
                <p class="card-text"><strong>Validity:</strong> {{ order.validity }} days</p>
                <p class="card-text"><strong>Data:</strong> {{ order.data }}</p>
                <p class="card-text"><strong>Price:</strong> {{ order.price }} {{ order.currency }}</p>
                <p class="card-text"><strong>Pricing Model:</strong> {{ order.pricing_model === 'net' ? 'Net Pricing' : order.pricing_model === 'retail' ? 'Retail Pricing' : order.pricing_model }}</p>
                <p class="card-text"><strong>Created:</strong> {{ formatDate(order.created_at) }}</p>
                @if (order.description) {
                  <p class="card-text"><strong>Description:</strong> {{ order.description }}</p>
                }
              </div>
              <div class="col-md-6">
                <h5 class="card-title">Installation Guides</h5>
                @if (order.installation_guides && order.installation_guides.en) {
                  <div class="mb-3">
                    <a [href]="order.installation_guides.en" target="_blank" class="btn btn-outline-primary">View Installation Guide</a>
                  </div>
                }
                @if (order.manual_installation) {
                  <div class="mb-3">
                    <h6>Manual Installation:</h6>
                    <div [innerHTML]="order.manual_installation | safeHtml"></div>
                  </div>
                }
                @if (order.qrcode_installation) {
                  <div class="mb-3">
                    <h6>QR Code Installation:</h6>
                    <div [innerHTML]="order.qrcode_installation | safeHtml"></div>
                  </div>
                }
              </div>
            </div>
            <!-- SIM Information -->
            @if (order.sims && order.sims.length > 0) {
              <div class="mt-4">
                <h5>SIM Information</h5>
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>ICCID</th>
                        <th>LPA</th>
                        <th>Matching ID</th>
                        <th>APN Type</th>
                        <th>Is Roaming</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (sim of order.sims; track sim) {
                        <tr>
                          <td>{{ sim.id }}</td>
                          <td>{{ sim.iccid }}</td>
                          <td>{{ sim.lpa }}</td>
                          <td>{{ sim.matching_id }}</td>
                          <td>{{ sim.apn_type }}</td>
                          <td>{{ sim.is_roaming ? 'Yes' : 'No' }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
            <!-- User Information -->
            @if (order.user) {
              <div class="mt-4">
                <h5>User Information</h5>
                <div class="row">
                  <div class="col-md-6">
                    <p><strong>Name:</strong> {{ order.user.name }}</p>
                    <p><strong>Email:</strong> {{ order.user.email }}</p>
                    <p><strong>Mobile:</strong> {{ order.user.mobile || 'N/A' }}</p>
                  </div>
                  <div class="col-md-6">
                    <p><strong>Company:</strong> {{ order.user.company }}</p>
                    <p><strong>Created:</strong> {{ formatDate(order.user.created_at) }}</p>
                  </div>
                </div>
              </div>
            }
            <!-- Status Information -->
            @if (order.status) {
              <div class="mt-4">
                <h5>Status Information</h5>
                <p><strong>Status:</strong>
                <span class="badge" [class]="'badge-' + (order.status.slug === 'completed' ? 'success' : order.status.slug === 'pending' ? 'warning' : 'danger')">
                  {{ order.status.name }}
                </span>
              </p>
            </div>
          }
        </div>
      </div>
    }

    <!-- No order message -->
    @if (!loading && !error && !order) {
      <div class="alert alert-info mt-3">
        Order not found.
      </div>
    }
  </div>
</div>
</div>